import { combineReducers } from "redux";
import imageReducer from "./imageReducer";
import originalImageReducer from "./originalImageReducer";

const state = {
  images: imageReducer,
  originalImages: originalImageReducer,
};

export default combineReducers(state);
